import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReportsComponent } from './reports/reports.component';
import { LeadsComponent } from './leads/leads.component';
import { MissingrecordingsComponent } from './missingrecordings/missingrecordings.component';
import { SpecsComponent } from './specs/specs.component';
import { UnapprovedsourcesComponent } from './unapprovedsources/unapprovedsources.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { RegisterComponent } from './register/register.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'app', component: AppComponent },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'reports', component: ReportsComponent },
  { path: 'leads', component: LeadsComponent },
  { path: 'missingrecordings', component: MissingrecordingsComponent },
  { path: 'specs', component: SpecsComponent },
  { path: 'unapprovedsources', component: UnapprovedsourcesComponent },
  { path: 'passwordreset', component: PasswordresetComponent },
  { path: 'register', component: RegisterComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})


export class AppRoutingModule { }
